import React from 'react';
import { parseLabMeasurement } from '../../utils/labMeasurement';

type LabResultsCannabinoidsRow = {
  key: string;
  rowId?: string;
  label: string;
  weight?: number;
  percent?: number;
  uom?: string;
  weightText?: string;
  percentText?: string;
  outcomeText?: string;
};

type LabResultsCannabinoidsTableProps = {
  rows: LabResultsCannabinoidsRow[];
  displayMode: 'Both' | 'Percent' | 'Weight';
};

const formatPercent = (value?: number) => {
  const measurement = parseLabMeasurement(value);
  if (measurement === undefined) return '';
  const fixed = measurement.toFixed(2);
  return `${fixed.replace(/\.00$/, '')}%`;
};

const formatWeight = (value?: number, unit = 'mg/g') => {
  const measurement = parseLabMeasurement(value);
  if (measurement === undefined) return '';
  const fixed = measurement.toFixed(3);
  return `${fixed.replace(/0+$/, '').replace(/\.$/, '')} ${unit}`;
};

export default function LabResultsCannabinoidsTable({ rows, displayMode }: LabResultsCannabinoidsTableProps) {
  const showWeight = displayMode === 'Both' || displayMode === 'Weight';
  const hasOutcomes = rows?.some(row => row?.outcomeText !== undefined);
  const showPercent = hasOutcomes || displayMode === 'Both' || displayMode === 'Percent';

  const visibleRows = (rows || []).filter(
    (row) => (showWeight && (row?.weightText !== undefined || parseLabMeasurement(row?.weight) !== undefined))
      || (showPercent && (row?.outcomeText !== undefined || row?.percentText !== undefined || parseLabMeasurement(row?.percent) !== undefined))
  );

  return (
    <div className="lab-results-preview-table-wrapper" data-testid="lab-results-cannabinoids">
      <table className="lab-results-preview-table" aria-label="Cannabis compounds" data-testid="lab-results-cannabinoids-table">
        <thead>
          <tr>
            <th>Cannabinoid</th>
            {showWeight && <th>Weight</th>}
            {showPercent && <th>{hasOutcomes ? 'Result' : 'Percent'}</th>}
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((row) => (
            <tr key={row.rowId ?? row.key} data-testid={`lab-results-cannabinoids-row-${row.rowId ?? row.key}`}>
              <td data-testid={`lab-results-cannabinoids-name-${row.rowId ?? row.key}`}>{row.label}</td>
              {showWeight && <td data-testid={`lab-results-cannabinoids-weight-${row.rowId ?? row.key}`}>{row.weightText ?? formatWeight(row.weight, row.uom || 'mg/g')}</td>}
              {showPercent && <td data-testid={`lab-results-cannabinoids-percent-${row.rowId ?? row.key}`}>{row.outcomeText ?? row.percentText ?? formatPercent(row.percent)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
